module.exports = __webpack_public_path__ + "static/img/05.69f33bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/03/05.jpg
// module id = 1izZ
// module chunks = 0